import { CALENDAR_DAY_LIMIT, TYPE_TIME_INTERVAL } from "@resources/Constants";
import moment from "moment";
import { useLang } from "./useLang";

interface ChartSelectMenuPrams {
  baseTime: {
    start: string;
    end: string;
  };
  isForPeopleQueuesAnalytics?: boolean;
}
export const useChartSelectMenu = (params: ChartSelectMenuPrams) => {
  const { start, end } = params.baseTime;
  const { translate } = useLang();
  const period = moment(end).diff(start, "day");

  return [
    {
      value: TYPE_TIME_INTERVAL.HOUR,
      label: translate("hour"),
      disabled: period > CALENDAR_DAY_LIMIT.ONE
    },
    {
      value: TYPE_TIME_INTERVAL.DAY,
      label: translate("day"),
      disabled: period > CALENDAR_DAY_LIMIT.FORTY_NINE
    },
    {
      value: TYPE_TIME_INTERVAL.WEEK,
      label: translate("week"),
      disabled: period < CALENDAR_DAY_LIMIT.TWO
    },
    {
      value: TYPE_TIME_INTERVAL.MONTH,
      label: translate("month"),
      disabled: period <= CALENDAR_DAY_LIMIT.FORTY_NINE
    }
  ];
};

export const useAnalyticsChartSelectMenu = (params: ChartSelectMenuPrams) => {
  const { start, end } = params.baseTime;
  const { translate } = useLang();

  return [
    {
      value: TYPE_TIME_INTERVAL.HOUR,
      label: translate("hour"),
      disabled: moment(end).diff(start, "day") >= CALENDAR_DAY_LIMIT.THIRTY
    },
    {
      value: TYPE_TIME_INTERVAL.DAY,
      label: translate("day"),
      disabled: false
    },
    {
      value: TYPE_TIME_INTERVAL.WEEK,
      label: translate("week"),
      disabled: false
    },
    {
      value: TYPE_TIME_INTERVAL.MONTH,
      label: translate("month"),
      disabled: moment(end).diff(start, "day") <= CALENDAR_DAY_LIMIT.TWENTY_NINE
    }
  ];
};

export const useAnalyticsChartMenu = (params: ChartSelectMenuPrams) => {
  const { start, end } = params.baseTime;
  const { translate } = useLang();
  if (params.isForPeopleQueuesAnalytics) {
    return [
      {
        value: TYPE_TIME_INTERVAL.HOUR,
        label: translate("hour"),
        disabled: moment(end).diff(start, "day") >= CALENDAR_DAY_LIMIT.TWO
      },
      {
        value: TYPE_TIME_INTERVAL.DAY,
        label: translate("day"),
        disabled: moment(end).diff(start, "day") >= CALENDAR_DAY_LIMIT.FIFTY
      },
      {
        value: TYPE_TIME_INTERVAL.WEEK,
        label: translate("week"),
        disabled: moment(end).diff(start, "day") < CALENDAR_DAY_LIMIT.THIRTEEN
      },
      {
        value: TYPE_TIME_INTERVAL.MONTH,
        label: translate("month"),
        disabled: moment(end).diff(start, "day") < CALENDAR_DAY_LIMIT.FIFTY
      }
    ];
  }
  return [
    {
      value: TYPE_TIME_INTERVAL.HOUR,
      label: translate("hour"),
      disabled: moment(end).diff(start, "day") >= CALENDAR_DAY_LIMIT.FOUR
    },
    {
      value: TYPE_TIME_INTERVAL.DAY,
      label: translate("day"),
      disabled: moment(end).diff(start, "day") >= CALENDAR_DAY_LIMIT.NINETY
    },
    {
      value: TYPE_TIME_INTERVAL.WEEK,
      label: translate("week"),
      disabled: moment(end).diff(start, "day") < CALENDAR_DAY_LIMIT.FOUR
    },
    {
      value: TYPE_TIME_INTERVAL.MONTH,
      label: translate("month"),
      disabled: moment(end).diff(start, "day") < CALENDAR_DAY_LIMIT.FOUR
    }
  ];
};
